.invisible {
  display: none;
}

.disabled {
  gz-light-grid {
    opacity: 0.6;
  }

  gz-text,
  gz-title,
  ::part(radio-label),
  ::part(checkbox-label) {
    color: var(--grey-layout-200-disabled);
  }

  gz-form-field {
    &::part(form-field-label) {
      color: var(--grey-layout-200-disabled);
    }
  }

  gz-link {
    pointer-events: none;
    opacity: 0.3;
  }
}

.wrapper {
  padding: calc(var(--spacer) * 5);
  flex-flow: column;
}

gz-info-box {
  padding: 0 0 calc(var(--spacer) * 2) 0;
}
